module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House16.514a9888.jpg";